/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

import { FormControl } from '@material-ui/core';

import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';

import DateFnsUtils from '@date-io/date-fns';
import ptBR from 'date-fns/locale/pt-BR';

export interface DataRangeProps {
  startValue: Date | null;
  startOnChange: (date: Date | null) => void;
  endValue: Date | null;
  endOnChange: (date: Date | null) => void;
}

export function DateRange({
  startValue,
  startOnChange,
  endValue,
  endOnChange,
}: DataRangeProps) {
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}>
        <FormControl fullWidth margin='normal' style={{ marginRight: 4 }}>
          <KeyboardDatePicker
            autoOk
            disableToolbar
            format='dd/MM/yyyy HH:mm:ss'
            onChange={startOnChange}
            value={startValue}
            variant='inline'
          />
        </FormControl>
        <FormControl fullWidth margin='normal' style={{ marginLeft: 4 }}>
          <KeyboardDatePicker
            autoOk
            disableToolbar
            format='dd/MM/yyyy HH:mm:ss'
            onChange={endOnChange}
            value={endValue}
            variant='inline'
          />
        </FormControl>
      </div>
    </MuiPickersUtilsProvider>
  );
}

export default DateRange;
